export enum RagAiModel {
  // Claude Models
  CLAUDE_5_5_HAIKU = 'CLAUDE_5_5_HAIKU',
  CLAUDE_5_5_SONNET = 'CLAUDE_5_5_SONNET',
  CLAUDE_5_5_OPUS = 'CLAUDE_5_5_OPUS',
  CLAUDE_4_5_HAIKU = 'CLAUDE_4_5_HAIKU',
  CLAUDE_4_5_OPUS = 'CLAUDE_4_5_OPUS',
  CLAUDE_4_6_OPUS = 'CLAUDE_4_6_OPUS',
  CLAUDE_4_5_SONNET = 'CLAUDE_4_5_SONNET',

  // Mistral Models
  MISTRAL_LARGE = 'MISTRAL_LARGE'
}

// Label suffix shows where the model processes data.
export const AI_MODEL_LABELS: Record<RagAiModel, string> = {
  [RagAiModel.CLAUDE_5_5_HAIKU]: 'Claude Haiku 5.5 (UK / EU)',
  [RagAiModel.CLAUDE_5_5_SONNET]: 'Claude Sonnet 5.5 (UK / EU)',
  [RagAiModel.CLAUDE_5_5_OPUS]: 'Claude Opus 5.5 (UK / EU)',
  [RagAiModel.CLAUDE_4_5_HAIKU]: 'Claude Haiku 4.5 (UK / EU)',
  [RagAiModel.CLAUDE_4_5_OPUS]: 'Claude Opus 4.5 (UK / EU)',
  [RagAiModel.CLAUDE_4_6_OPUS]: 'Claude Opus 4.6 (UK / EU)',
  [RagAiModel.CLAUDE_4_5_SONNET]: 'Claude Sonnet 4.5 (UK / EU)',

  [RagAiModel.MISTRAL_LARGE]: 'Mistral Large (UK)'
};

// Claude 4.7 and later reject a non-default temperature; the backend ignores it for these.
export const MODELS_WITHOUT_TEMPERATURE: ReadonlySet<RagAiModel> = new Set([
  RagAiModel.CLAUDE_5_5_HAIKU,
  RagAiModel.CLAUDE_5_5_SONNET,
  RagAiModel.CLAUDE_5_5_OPUS
]);

export const supportsTemperature = (model: string | undefined): boolean =>
  !MODELS_WITHOUT_TEMPERATURE.has(model as RagAiModel);

export const DEFAULT_AI_MODEL = RagAiModel.CLAUDE_5_5_SONNET;
